module.exports = __webpack_public_path__ + "img/pip-fill.7800103b.svg";